//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            answers: [
                {
                    label: this.$lang.get('w3d4.game4.plates'),
                    correct: false,
                    clicked: false
                },
                {
                    label: this.$lang.get('w3d4.game4.windows'),
                    correct: true,
                    clicked: false,
                    image: '/images/game/w3d4/windows.png',
                    zIndex: 2
                },
                {
                    label: this.$lang.get('w3d4.game4.doorknob'),
                    correct: false,
                    clicked: false
                },
                {
                    label: this.$lang.get('w3d4.game4.insulation'),
                    correct: true,
                    clicked: false,
                    image: '/images/game/w3d4/new_front.png',
                    zIndex: 1
                },
                {
                    label: this.$lang.get('w3d4.game4.bread'),
                    correct: false,
                    clicked: false
                },
                {
                    label: this.$lang.get('w3d4.game4.roof'),
                    correct: true,
                    clicked: false,
                    image: '/images/game/w3d4/roof.png',
                    zIndex: 3
                },
                {
                    label: this.$lang.get('w3d4.game4.solar'),
                    correct: true,
                    clicked: false,
                    image: '/images/game/w3d4/solar.png',
                    zIndex: 4
                },
                {
                    label: this.$lang.get('w3d4.game4.color'),
                    correct: false,
                    clicked: false
                },
                {
                    label: this.$lang.get('w3d4.game4.kettle'),
                    correct: true,
                    clicked: false,
                    image: '/images/game/w3d4/heating.png',
                    zIndex: 5
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.answers.filter(answer => answer.correct && answer.clicked).length;
            let numTotalCorrect = this.answers.filter(answer => answer.correct).length;
            let numWrong = this.answers.filter(answer => !answer.correct && answer.clicked).length;

            return this.$game.getMultipleChoiceResult(numCorrect, numTotalCorrect, numWrong);
        },
        indicatorAngle () {
            let numCorrect = this.answers.filter(answer => answer.correct && answer.clicked).length;
            let numTotalCorrect = this.answers.filter(answer => answer.correct).length;

            return 0 + (numCorrect / numTotalCorrect) * 180;
        }
    }
};
